export default __webpack_public_path__ + "static/media/mode-32.4094fece.svg";